<div>
	<his-search-form configFile="fs/res/searchPersons.xml"></his-search-form>
</div>
